/* eslint-disable */
import React, { useCallback, useState, useMemo, useEffect, useRef } from 'react';
import {NavLink, Link} from 'react-router-dom';
import { Info } from 'lucide-react';
import * as Tooltip from '@radix-ui/react-tooltip';
import { useDispatch, useSelector } from 'react-redux';
import { FaGlobe } from "react-icons/fa";

import 'react-phone-input-2/lib/style.css'
import {editLang} from "../store/reducers/langSlice.js"
import {editCountry, setResidenceCountry, setActivityCountry} from "../store/reducers/countrySlice.js"
import Domain_Switch from './Domain_Switch.js';
import countryList from 'react-select-country-list';
import CountrySelect from './CountrySelect.js';

const TopHeader = ({ fixed, transparent }) => {
    const actualCountry = useSelector((state) => state.country.country);
  // Worldwide Country setup
  const dispatch = useDispatch();
  const worldWideCountriesOptions = useMemo(() => countryList().getData(), []);

  const [currentCountry, setCurrentCountry] = useState('');

    const activityCountry =
        useSelector(
            state =>
                state.country.activityCountry
        );

  const [selectedCountry, setSelectedCountry] = useState(null);

  // Only African Countries
    const africanCountryCodes = [
        "DZ","AO","BJ","BW","BF","BI","CM","CV","CF","TD","KM","CD","CG",
        "CI","DJ","EG","GQ","ER","SZ","ET","GA","GM","GH","GN","GW","KE",
        "LS","LR","LY","MG","MW","ML","MR","MU","MA","MZ","NA","NE","NG",
        "RW","ST","SN","SC","SL","SO","ZA","SS","SD","TZ","TG","TN","UG",
        "EH","ZM","ZW"
    ];

    const africanCountriesOptions = useMemo(() => {
        return countryList()
            .getData()
            .filter((country) => africanCountryCodes.includes(country.value));
    }, []);

    // Only West African Countries
    const westAfricaCountryCodes = [
        'BJ', // Benin
        'BF', // Burkina Faso
        'CV', // Cape Verde
        'CI', // Côte d'Ivoire
        'GM', // Gambia
        'GH', // Ghana
        'GN', // Guinea
        'GW',  //Guinea-Bissau
        'LR', // Liberia
        'ML', // Mali
        'MR',  // Mauritania
        'NE', // Niger
        'NG', // Nigeria
        'SN', // Senegal
        'SL',  // Sierra Leone
        'TG',  // Togo
        'CM', // Cameroon
        'MA',
        'ZA'
    ];

    const options = useMemo(() => {
        return countryList()
            .getData()
            .filter((country) => westAfricaCountryCodes.includes(country.value));
    }, []);

    // UseEffect refactored
    useEffect(() => {

        const initializeCountry = async () => {

            //
            // 1. URL
            //
            const params =
                new URLSearchParams(
                    window.location.search
                );

            const urlCountry =
                params.get(
                    "activityCountry"
                );

            const localStorageCountry =
                localStorage.getItem("activityCountry");

            if(localStorageCountry){

                const parsed =
                    JSON.parse(localStorageCountry);

                const matched =
                    options.find(
                        c =>
                            c.value === parsed.value
                    );

                if(matched){

                    dispatch(setActivityCountry(matched));
                    dispatch(editCountry(matched));

                    return;
                }
            }

            if(urlCountry){

                const matched =
                    options.find(
                        c =>
                            c.value.toUpperCase() === urlCountry?.toUpperCase()
                    );

                if(matched){

                    dispatch(
                        setActivityCountry(
                            matched
                        )
                    );

                    dispatch(
                        editCountry(
                            matched
                        )
                    );

                    return;
                }
            }

            //
            // 2. Cookie
            //
            const cookieCountry =
                getCookie(
                    "activityCountry"
                );

            if(cookieCountry){

                const matched =
                    options.find(
                        c =>
                            c.value === cookieCountry
                    );

                if(matched){

                    dispatch(
                        setActivityCountry(
                            matched
                        )
                    );

                    dispatch(
                        editCountry(
                            matched
                        )
                    );

                    return;
                }
            }

            //
            // 3. IP
            //
            try{

                const res =
                    await fetch(
                        "https://ipapi.co/json/"
                    );

                const data =
                    await res.json();

                const matched =
                    options.find(
                        c =>
                            c.value ===
                            data.country?.toUpperCase()
                    );

                if(matched){

                    dispatch(
                        setResidenceCountry(
                            matched
                        )
                    );

                    // Aucun choix explicite (localStorage, URL, cookie) :
                    // le pays détecté devient aussi le pays d'activité, qui
                    // pilote la devise.
                    dispatch(
                        setActivityCountry(
                            matched
                        )
                    );

                    dispatch(
                        editCountry(
                            matched
                        )
                    );

                }

            }catch(error){

                console.error(error);

            }

        };

        initializeCountry();

    }, []);

    const getCookie = (name) => {

        const value =
            `; ${document.cookie}`;

        const parts =
            value.split(
                `; ${name}=`
            );

        if(parts.length === 2){

            return parts
                .pop()
                .split(';')
                .shift();
        }

        return null;
    }

    const handleCountryChange = (option) => {

        if(!option) return;

        dispatch(
            setActivityCountry(option)
        );

        dispatch(
            editCountry(option)
        );

        localStorage.setItem(
                "activityCountry",
                JSON.stringify(option)
        );

        localStorage.setItem(
                "countrySelectedManually",
                "true"
        );

        const isLocalhost =
            window.location.hostname === "localhost";

        // document.cookie =
        //     `activityCountry=${option.value};
        // domain=.assiganto-agro.com;
        // path=/;
        // max-age=31536000;
        // ${isLocalhost ? "" : "secure"}`;

        document.cookie =
            isLocalhost
                ? `activityCountry=${option.value};path=/`
                : `activityCountry=${option.value};domain=.assiganto-agro.com;path=/;max-age=31536000;secure`;

        const domainMap = {
            TG: "togo.assiganto-agro.com",
            BJ: "benin.assiganto-agro.com",
            NG: "nigeria.assiganto-agro.com",
            CM: "cameroon.assiganto-agro.com",
            DE: "germany.assiganto-agro.com",
            GH: "ghana.assiganto-agro.com",
            CI: "ci.assiganto-agro.com",
            SN: "senegal.assiganto-agro.com"
        };


        const targetDomain =
            domainMap[option.value];

        if(!isLocalhost && targetDomain){

            const {
                pathname,
                search,
                hash
            } = window.location;

            const url = new URL(window.location.href);

            url.hostname = targetDomain;

            url.searchParams.set(
                "activityCountry",
                option.value
            );

            window.location.href = url.toString();
        }

        console.log("option", option);
        console.log("option.value", option?.value);
        console.log("targetDomain", targetDomain);

    }

  // Language setup
  const language_code = useSelector((state) => state.lang)
   
  const chooseLanguageHandler = (value) => {
    dispatch(editLang(value));
  }
  
  const stringList = ["Nigeria", "Togo", "Cameroon", "Côte d'Ivoire", "Senegal"];

    const selectedOption =
        options.find(
            c =>
                c.value ===
                activityCountry?.value
        ) || null;

  return (<>
  <header className="header-top-strip">
    <div className='container-xxl'>
      <div className='row align-items-center flex-nowrap'>
      
       <div className='col-auto d-flex align-item-center justify-content-start'>
         <div className="center-feedback-country">
         <div className="mx-2 mx-md-4" data-tour="country">
             {/*<CountrySelect*/}
             {/*    value={selectedOption}*/}
             {/*    onChange={handleCountryChange}*/}
             {/*    options={options}*/}
             {/*    placeholder={actualCountry?.label}*/}
             {/*/>*/}
             <CountrySelect
                 value={selectedOption}
                 onChange={handleCountryChange}
                 options={options}
             />
         </div>
       </div>

       </div>
              
       <div className='col text-white d-flex flex-column align-item-center justify-content-center d-none d-md-block'>
       {(stringList.includes(actualCountry.label)) ? <p className='center-country-welcome mt-3'>Bienvenue à Assiganto {actualCountry.label}</p> :
       <div className="text-sm text-gray-700 flex items-center gap-1">
        
         <div className='center-country-welcome d-flex flex-row'>
          <p>Assiganto arrive dans votre pays {actualCountry.label}</p>
          <p className='p-2'>
            <Tooltip.Provider>
              <Tooltip.Root className="transform -translate-y-2">
                <Tooltip.Trigger asChild>
                  <Info size={14} className="text-white-500 cursor-pointer" />
                </Tooltip.Trigger>
                <Tooltip.Portal>
                  <Tooltip.Content
                    className="bg-gray-800 welcome-popup text-xs rounded px-4 py-0 shadow-md"
                    side="top"
                    sideOffset={2}
                  >
                    Actuellement au Nigeria, Togo, Côte d'Ivoire et Cameroon
                    <Tooltip.Arrow className="fill-gray-800" />
                  </Tooltip.Content>
                </Tooltip.Portal>
              </Tooltip.Root>
            </Tooltip.Provider>
            </p> 
         </div>
       </div>
       }
       </div>

       <div className='col-auto ms-auto d-flex align-items-center justify-content-end gap-15'>
          <div className='dropdown d-flex align-item-center justify-content-center'>
              <button className="btn btn-secondary dropdown-toggle bg-transparent border-0 gap-15 d-flex align-items-center" 
                      type="button" 
                      id="dropdownMenuButton1" 
                      data-tour="language"
                      data-bs-toggle="dropdown" 
                      aria-expanded="false">
                  <FaGlobe className='fs-2' color="#febd69" />
              </button>
              <ul className="dropdown-menu min-width-0 " aria-labelledby="dropdownMenuButton1" id="language">          
                    <Link className="dropdown-item text-black" onClick={() => chooseLanguageHandler('FR')}>FR</Link>
                    <Link className="dropdown-item text-black" onClick={() => chooseLanguageHandler('EN')}>EN</Link>
                    {/*<Link className="dropdown-item text-black" onClick={() => chooseLanguageHandler('DE')}>DE</Link>*/}
              </ul>
          </div>
          <div className='mt-3 d-none d-md-block'>
              <Domain_Switch />
          </div>
       </div>
      </div>
    </div>
  </header>

  </>);
}
export default TopHeader